var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{ref:"elRef",staticClass:"article-card relative",style:(_vm.style),on:{"click":_vm.onClick}},[(_vm.isMobile)?[_vm._t("mobile")]:[_vm._t("desktop")],_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }